import React from 'react';
import Slide from '@material-ui/core/Slide';

export default function SlideTransition(props) {
    return <Slide direction="up" {...props} />;
}


// WEBPACK FOOTER //
// ./src/Components/Presentation/_Shared/Transitions/SlideTransition.js